// extracted by mini-css-extract-plugin
export default {"button":"_2wYyx","formButton":"_1Mpaw","form":"_1qx_c","responses":"_2S-Ql","response":"Ga7CW","error":"_1OGwZ","summaryBlock":"_1rk0T","fullButton":"_2mUnU","title":"_3Bqur"};